import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";

//A React component will allow us to quickly iterate and change our code. It provides 
class AlertRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
    }

    toggleDropdown(id, item) {
        if (this.props.closeDropdown) {
            this.props.closeDropdown(id)
        }

        const element = document.getElementById(id);
        if (!element) return;

        if(element.classList.contains('is-open')) {
            element.classList.remove('is-open');
        } else {
            $('.dropdown-pane').removeClass('is-open');
            $('.alert-menu-item').removeClass('is-active');
            element.classList.add('is-open');
        }
    }

    render() {
        return (
            <a className = "alert-menu-item" id = {this.props.id} onClick={()=>this.toggleDropdown(this.props.datatoggle,this.props.id)}>
                {
                    this.props.count > 0 ?
                            <div className = "alert-bubble" style={{opacity: 1, pointerEvents: "none"}}>
                                {this.props.count}
                            </div>
                        :
                            <div className = "alert-bubble" style={{opacity: 0, pointerEvents: "none"}}>
                                
                            </div>
                }                

                {this.props.icon()}

                <p className = "caption align-center" style={{pointerEvents: "none"}}>{this.props.name}</p>
            </a>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
});

export default connect(mapStateToProps)(AlertRow);